import { makeStyles } from "@material-ui/core";

export const emptyStateStyles = makeStyles((theme) => ({
  title: {
    color: "#000000",
    fontFamily: "Lato",
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(16),
    lineHeight: theme.typography.pxToRem(19),
    marginBottom: theme.typography.pxToRem(37),
  },
  suggestionTitle: {
    fontWeight: 600,
    color: "#000000",
    fontFamily: "Lato",
    fontSize: theme.typography.pxToRem(16),
    lineHeight: theme.typography.pxToRem(19),
    marginBottom: theme.typography.pxToRem(16),
  },
  suggestionContainer: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    marginBottom: theme.typography.pxToRem(31),
    "& svg": {
      height: theme.typography.pxToRem(16),
      width: theme.typography.pxToRem(12),
      marginRight: theme.typography.pxToRem(8),
      "& path": {
        fill: "#666666",
      },
    },
  },
  suggestion: {
    fontFamily: "'Inter',regular",
    lineHeight: theme.typography.pxToRem(24),
    fontSize: theme.typography.pxToRem(16),
    color: "#666666",
    fontWeight: 400,
  },
  red: {
    color: "#F15A28",
    marginRight: theme.typography.pxToRem(5),
  },
}));
